export default {
	'search': require('../../../../assets/images/icon/wind-ui/icon-search.png'),
	'search-clear': require('../../../../assets/images/icon/wind-ui/icon-search-clear.png')
}



// WEBPACK FOOTER //
// ./src/lib/wind-ui/js/config/icon_url.js